export const DEFAULT_SUMMARY_DATA = {
  totalSales: 0,
  totalCost: 0,
  ordersCount: 0,
  soldProductsCount: 0,
  profit: 0,
  averageCheck: 0,
  averageOrderFill: 0,
};
